export const keyPath = (parent, key) => (parent ? `${parent}.${key}` : key);
export const traverseShape = (shape, parent = '') => {
    const target = {};

    for (const [key, value] of Object.entries(shape)) {
        const path = keyPath(parent, key);

        if (typeof value === 'string') {
            target[key] = path;
        } else {
            target[key] = traverseShape(value, path);
        }
    }

    return target;
};
